// extracted by mini-css-extract-plugin
export default {"menuItem":"ContextMenu_menuItem__DvFRN"};